import { isJDiwork } from "../../utils"
import lang from "ac-lang-cn"
import './index.less';

export default function dialog(dialog, index, storeProps, modalRootId) {
  const { showModal, bodyStyle, zIndex, mask, modalProps, titleView, contentView, footerView } = dialog
  const terminalType = storeProps.query.terminalType

  const closeDialog = () => {
    if (contentView.rootStore) {
      const goBackAction = Object.values(contentView.rootStore.actions).find((v) => v?.controlType === 'goBack')
      storeProps.setResult(goBackAction?.params)
    }
    storeProps.closeDialog(index)
  }

  // 单据类弹窗，缺的参数用默认的补全
  if (contentView.billNo && contentView.query) {
    // 处理新开页签的query
    contentView.query = {
      domainKey: storeProps.query.domainKey,
      serviceCode: storeProps.query.serviceCode,
      terminalType: storeProps.query.terminalType,
      busiObj: storeProps.query.busiObj,
      ...contentView.query
    }
    if (storeProps.query.transtype !== undefined) {
      contentView.query.transtype = storeProps.query.transtype
    }
    if (storeProps.query.metaCache !== undefined) {
      contentView.query.metaCache = storeProps.query.metaCache
    }
    // 处理新开页签的params
    contentView.params = { ...contentView.params, diworkCode: storeProps.params.diworkCode, pageIsModal: true }
    // 设置关闭的回调
    dialog.setCloseDialog(closeDialog)
    dialog.contentView.onRootStoreCreated = (rootStore) => {
      dialog.contentView.rootStore = rootStore
    }
  }

  // pc端弹窗
  const getPCModal = () => {
    const { Modal, Drawer, ConfigProvider } = TinperNext
    if (!Modal || !Drawer || !ConfigProvider) {
      return undefined
    }

    const { title } = titleView
    const { containerType } = contentView

    if (containerType === 'drawer') {
      const { width = 1200, height = '100%' } = bodyStyle || {};
      return <ConfigProvider locale={lang.getLanguage()}>
        <Drawer
          width={width}
          height={height}
          {...modalProps}
          className='fragment-drawer-view'
          placement='right'
          mask={mask}
          title={title}
          hasHeader={!!title}
          visible={showModal}
          closable={!!title}
          destroyOnClose={true}
          zIndex={zIndex}
          getPopupContainer={() => document.getElementById(modalRootId)}
          onClose={closeDialog}
        >
          { contentView.render() }
        </Drawer>
      </ConfigProvider>
    } else {
      // bodyStyle传宽度高度的话，就对width、height不做限制只限制最小值；bodyStyle没有传宽度高度的话，modal默认的宽度高度就是1200/800
      return <ConfigProvider locale={lang.getLanguage()}>
        <Modal
          width={bodyStyle?.width ? undefined : '85%'}
          height={bodyStyle?.height ? undefined : '85%'}
          minWidth={bodyStyle?.width || undefined}
          minHeight={bodyStyle?.height || undefined}
          {...modalProps}
          className='fragment-modal-view'
          mask={mask}
          header={null}
          footer={null}
          centered={!isJDiwork()}
          showPosition={isJDiwork() ? { y: 32 } : {}}
          draggable
          visible={showModal}
          destroyOnClose={true}
          bodyStyle={bodyStyle}
          zIndex={zIndex}
          getPopupContainer={() => document.getElementById(modalRootId)}
          onCancel={closeDialog}
        >
          { titleView.render() }
          <Modal.Body>
            { contentView.render() }
          </Modal.Body>
          { footerView.render() }
        </Modal>
      </ConfigProvider>
    }
  }
  // 移动端弹窗
  const getMobileModal = () => {
    const Popup = window['TinperM']?.Popup
    if (!Popup) {
      return undefined
    }

    return <Popup {...modalProps} visible={showModal} mask={mask} onMaskClick={closeDialog} bodyStyle={{
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
      textAlign: 'center',
      height: '80vh',
      ...bodyStyle
    }}>
      { contentView.render() }
    </Popup>
  }

  return <>
    { showModal ? terminalType == 3 ? getMobileModal() : getPCModal() : <div></div> }
  </>
}
